'use strict';

angular.module('mx.SolutionBuilderAgent').controller('mx.SolutionBuilderAgent.EditInWorkflowStudioController', [
	'mx.shell.Config',
	'mx.SolutionBuilderAgent.Http',
	function editInWorkflowStudioCtrl(mxConfig, http) {
		const vm = this;
		const host = (mxConfig.get('imgHosts') || {}).default;

		vm.execute = function (selectedObjects) {
			const id = (selectedObjects || []).length > 0 ? selectedObjects[0].WorkflowId || selectedObjects[0].ID || selectedObjects[0].Id : undefined;

			http.get('api/workflow/studio/' + (id || '') + '/url').then(function (url) {
				window.open(host + url);
			});
		};
	},
]);
